





import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component
export default class JdsFieldRow extends Vue {
}
